<template>
  <div class="rule">
    <div class="rule-claim">
      <div class="title">参赛要求</div>
      <div class="content">
        <div class="item">
          报名参加私募大赛的私募机构需具备私募基金管理资质，并且是进行二级市场投资的私募证券投资基金管理人。
        </div>
        <div class="item">
          参赛私募基金管理人的管理规模原则上需在1亿以上；其他情形需和大赛组委会沟通，经大赛组委会审核通过可报名。
        </div>
        <div class="item">
          参赛产品规模需在500万以上（不强制要求在申万宏源证券营业部开户）；其他情形需和大赛组委会沟通，经大赛组委会审核通过可报名。
        </div>
        <div class="item">
          同一策略分组下，原则上一家私募基金管理人只能1个产品参赛；其他情形需和大赛组委会沟通，经大赛组委会审核通过可报名。
        </div>
      </div>
      <p class="tips">报名和参赛的相关问题可咨询大赛组委会。</p>
    </div>
    <div class="rule-class">
      <div class="title">参赛组别</div>
      <p class="tips">
        按照策略划分为权益组、相对价值&amp;混合策略组、CTA组和期权组，按照参赛产品的资产规模进行划分，可以分为以下组别：
      </p>
      <div class="content">
        <div class="item">
          <div class="left">权益组</div>
          <div class="right">
            <div>
              大资产规模组
              <p>（5000万元以上）</p>
            </div>
            <div>
              小资产规模组
              <p>（500万-5000万元）</p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <p style="margin-right: 5px">混合策略组</p>
            <p>相对价值</p>
          </div>
          <div class="right">
            <div>
              大资产规模组
              <p>（5000万元以上）</p>
            </div>
            <div>
              小资产规模组
              <p>（500万-5000万元）</p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left" style="flex-direction: column">
            <span>CTA</span>组
          </div>
          <div class="right">
            <div>
              大资产规模组
              <p>（2000万元以上）</p>
            </div>
            <div>
              小资产规模组
              <p>（500万-2000万元）</p>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="left">期权组</div>
          <div class="right">
            <div>
              此组参赛选手
              <p>不根据资产规模进行分组</p>
            </div>
          </div>
        </div>
      </div>
      <p class="sub-tips">
        说明：权益组以股票为主要投资标的，包含股票多头、股票多空、指数增强策略、量化选股策略、股票多头+择时对冲等策略。相对价值&amp;混合策略包含市场中性策略、复合套利策略、其他套利策略、混合策略等。CTA组以期货市场各品种为投资方向，包含主观期货、程序化期货策略等。期权组以期权为主要投资方向，包括期权波动率策略、做市商策略等。私募管理人根据自身产品特色选择报名组别。
      </p>
    </div>
    <div class="rule-investment">
      <div class="title">投资规则</div>
      <div class="rule-investment-content">
        <div class="item">
          <span>规则一</span>
          <p class="title">权益组投资限制</p>
          <p class="content">
            比赛期间，产品或账户应进行组合投资，原则上不得仅持有单只股票超过1个月；产品或账户可投资股指期货、股票期权。
          </p>
        </div>
        <div class="item">
          <span>规则二</span>
          <p class="title">相对价值&amp;混合策略投资限制</p>
          <p class="content">
            比赛期间，交易策略应符合监管及公司的规定，不得有引发市场价格波动的交易策略和交易行为。
          </p>
        </div>
        <div class="item">
          <span>规则三</span>
          <p class="title">CTA组投资限制</p>
          <p class="content">
            持有非期货权益类资产（股票、股票型基金、混合型基金、债券、集合资产管理计划等）的总值不得超过产品资产净值的30%。
          </p>
        </div>
      </div>
    </div>
    <div class="rule-data">
      <div class="title">数据报送</div>
      <div class="rule-data-content">
        <div class="item">
          <span>01</span>
          <p class="title">报送时间</p>
          <p class="content">
            每周净值在当周交易结束后的第五个交易日前完成数据报送。
          </p>
        </div>
        <div class="item">
          <span>02</span>
          <p class="title">报送范围</p>
          <p class="content">
            产品策略、单位净值、累计净值、产品资产净值(周频)、分红/拆分 。
          </p>
        </div>
        <div class="item">
          <span>03</span>
          <p class="title">基金外包服务机构发送</p>
          <p class="content">
            参赛机构须授权参赛产品的基金外包服务机构，在每周报送时间截止前将上周最后一个交易日产品的单位净值、累计净值、产品资产净值数据发送到大赛指定邮箱：data@simuwang.com
          </p>
        </div>
      </div>
    </div>
    <div class="rule-selection">
      <div class="title">评选标准</div>
      <div class="rule-selection-content">
        <p class="tips">参赛选手需每周报送一次数据并保证数据的真实性</p>
        <div class="month">
          <p class="title">月度、季度奖项规则</p>
          <table>
            <tr>
              <td width="200"></td>
              <td colspan="3" class="bg-color">指标</td>
              <td colspan="3" class="bg-color">权重</td>
            </tr>
            <tr>
              <td rowspan="3">
                <div class="f-c-c">综合得分</div>
              </td>
              <td colspan="3">年化收益率标准分</td>
              <td colspan="3">40%</td>
            </tr>
            <tr>
              <td colspan="3" class="bg-color2">最大回撤标准分</td>
              <td colspan="3" class="bg-color2">30%</td>
            </tr>
            <tr>
              <td colspan="3">收益风险比标准分</td>
              <td colspan="3">30%</td>
            </tr>
            <tr>
              <td></td>
              <td colspan="6">
                <p>备注：</p>
                <p>1.月度、季度奖项评选根据定量评价指标打分确定奖项</p>
                <p>2.各指标的得分均采用相对得分法</p>
              </td>
            </tr>
          </table>
        </div>
        <div class="year">
          <p class="title">年度奖项规则</p>
          <table>
            <tr>
              <td width="200" rowspan="5">
                <div class="f-c-c">综合得分</div>
              </td>
              <td colspan="2" class="bg-color">一级指标</td>
              <td class="bg-color">权重</td>
              <td colspan="2" class="bg-color">指标</td>
              <td class="bg-color">权重</td>
            </tr>
            <tr>
              <td colspan="2" rowspan="3">定量得分</td>
              <td rowspan="3">75%</td>
              <td colspan="2">年化收益率标准分</td>
              <td>40%</td>
            </tr>
            <tr>
              <td colspan="2" class="bg-color2">最大回撤标准分</td>
              <td class="bg-color2">30%</td>
            </tr>
            <tr>
              <td colspan="2">收益风险比标准分</td>
              <td>30%</td>
            </tr>
            <tr>
              <td colspan="2" class="bg-color2">定性得分</td>
              <td class="bg-color2">25%</td>
              <td colspan="2" class="bg-color2">--</td>
              <td class="bg-color2">--</td>
            </tr>
            <tr>
              <td></td>
              <td colspan="6">
                <p>备注：</p>
                <p>1.年度奖项评选采用定量+定性的方式确定排名</p>
                <p>
                  2.定量部分各指标的得分均采用相对得分法，定性得分为专家评审打分，对团队背景、从业经验、产品创新、投研能力等方面进行综合评判。大赛邀请申万宏源证券的专业人士对私募管理人进行尽职调查、邀请研究所分析师、私募基金经理等知名大咖作为专家评审参与打分提升评选公正力。
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="rule-disclaimer">
      <div class="title">风险及免责条款</div>
      <div class="rule-disclaimer-content">
        <p>
          1、本次私募大赛为实盘竞赛，参赛私募基金管理人需以自己发行和管理的私募基金产品参赛，自负盈亏。参赛私募基金管理人的参赛产品自行承担和支付比赛所需的交易资金、托管费、外包服务费、上网费、因参加比赛产生的任何其他费用及其它根据法律法规、指定交易商的相关交易规则由参赛机构承担的任何费用。除向优胜机构提供奖励外，大赛组委会不会对参赛机构支付任何费用或承担参赛机构的任何开支；
        </p>
        <p>
          2、参赛机构的所有交易须遵守相关法律法规。大赛组委会发现或有人举报，经核实后参赛机构确有舞弊行为或非法募集资金、操纵市场、内幕交易等违法违规行为，立即取消参赛机构的参赛资格；由此产生的一切后果由参赛机构承担；
        </p>
        <p>
          3、本次大赛组委会将本着公平、公正、专业的原则保障大赛的顺利进行。但不对因不可抗力的因素或非大赛组委会所能控制的情况所导致的任何风险、系统故障或由于网络问题导致的系统故障等原因对参赛选手收益率及排名产生的影响等承担任何责任。参赛机构必须保护好自己的相关密码，如因为密码丢失或被破解所导致的账户被窃而造成损失的，大赛组委会不负任何责任；
        </p>
        <p>
          4、本次大赛披露的排名等相关信息仅限大赛范围参考，不构成对投资者投资参赛机构及其管理的私募产品的投资建议；对此产生的影响，大赛组委会不负任何责任；
        </p>
        <p>
          5、本次大赛参赛机构所提供的基金产品必须保证数据真实有效，参赛期间大赛组委会有权要求参赛选手提供托管数据进行复核；但不构成外部投资建议；对此产生的影响主办方不负任何责任；
        </p>
        <p>
          6、大赛组委会在比赛期间所提供的信息，资料及图标仅供参考，并不构成对任何股票的收购、购买、认购、抛售或持有的邀约或意图，市场有风险，投资需谨慎；
        </p>
        <p>
          7、大赛组委会接受参赛机构参与本次大赛，不代表大赛组委会对参赛机构及其管理的基金产品的推荐、营销、宣传，不代表主办方与参赛机构之间存在基金产品销售委托代理关系。参赛机构不得利用主办方的名义、商标、商号或者本次大赛名义进行基金宣传、募集活动；
        </p>
        <p>
          8、本次比赛的奖励、评分标准、方案、规则等最终解释权归大赛组委会所有，大赛组委会有权根据实际情况进行修改或取消。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.rule {
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 145px;
  > div > .title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 61px;
    background: url("../assets/img/title-bg.png") no-repeat center / 100% 100%;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
  }
}
.rule-claim {
  .content {
    padding-top: 56px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    .item {
      width: 290px;
      height: 265px;
      font-size: 16px;
      color: #fff;
      padding: 0 28px;
      padding-top: 123px;
      line-height: 24px;
      &:nth-child(1) {
        background: url("../assets/img/rule-claim-bg1.png") no-repeat center /
          100% 100%;
      }
      &:nth-child(2) {
        background: url("../assets/img/rule-claim-bg2.png") no-repeat center /
          100% 100%;
      }
      &:nth-child(3) {
        background: url("../assets/img/rule-claim-bg3.png") no-repeat center /
          100% 100%;
      }
      &:nth-child(4) {
        background: url("../assets/img/rule-claim-bg4.png") no-repeat center /
          100% 100%;
      }
    }
  }
  .tips {
    margin-top: 29px;
    font-size: 20px;
    color: #fff;
    text-align: center;
  }
}
.rule-class {
  padding-top: 85px;
  .tips {
    margin-top: 56px;
    font-size: 18px;
    color: #fff;
    text-align: center;
  }
  .content {
    padding-top: 13px;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    > div {
      width: 590px;
      height: 250px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin-top: 20px;
      .left {
        width: 115px;
        border-right: 2px solid #040b85;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 43px;
        line-height: 25px;
        span {
          display: block;
          margin-bottom: 10px;
          -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
        }
      }
      .right {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        > div {
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          text-align: center;
          line-height: 36px;
        }
        div:nth-child(2) {
          border-top: 2px solid #040b85;
        }
      }
    }
    .item:nth-child(1) {
      background-color: #3d49ac;
    }
    .item:nth-child(2) {
      background-color: #6b76cb;
    }
    .item:nth-child(3) {
      background-color: #c9ab56;
    }
    .item:nth-child(4) {
      background-color: #b38a1f;
    }
  }
  .sub-tips {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 19px;
    line-height: 15px;
  }
}
.rule-investment,
.rule-data {
  padding-top: 93px;
}
.rule-investment-content,
.rule-data-content {
  padding-top: 56px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  .item {
    width: 390px;
    height: 235px;
    border: 1px solid #3945a8;
    p {
      margin-bottom: 0;
    }
    span {
      display: block;
      width: 85px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #3945a8;
      font-size: 16px;
      color: #fff;
    }
    .title {
      margin-top: 29px;
      padding-left: 20px;
      font-size: 20px;
      color: #fff;
    }
    .content {
      margin-top: 25px;
      padding: 0 20px;
      color: #fff;
      font-size: 18px;
      line-height: 24px;
    }
  }
}
.rule-selection {
  padding-top: 77px;
  .rule-selection-content {
    padding-top: 20px;
    > div {
      padding-top: 44px;
      .title {
        font-size: 20px;
        color: #fff;
      }
    }
    .tips {
      text-align: center;
      font-size: 16px;
      color: #fff;
      margin-top: 41px;
    }
  }
  table {
    width: 100%;
    margin-top: 21px;
    color: #fff;
    font-size: 16px;
    border-collapse: collapse;
    td {
      position: relative;
      border: 1px solid #3945a8;
      padding: 15px 27px;
      p {
        line-height: 30px;
      }
    }
    .bg-color {
      background-color: #3945a8;
    }
    .bg-color2 {
      background-color: rgba(61, 73, 172, 0.4);
    }
    .f-c-c {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
  }
}
.rule-disclaimer {
  padding-top: 67px;
  .rule-disclaimer-content {
    padding-top: 46px;
    font-size: 16px;
    color: #fff;
    line-height: 30px;
  }
}
</style>